unit UDatamodule;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Modules, Data.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  XData.Web.Connection, WEBLib.DB, Sphinx.WebLogin, WEBLib.JSON
  {$IFDEF DEBUG}
  ,WEBLib.WebTools
  {$ENDIF}
  , WEBLib.REST, WEBLib.Dialogs, System.UITypes, WEBLib.Forms, WEBLib.Controls, ULogin;

type
  TUDM = class(TDataModule)
    XDataWebConnection: TXDataWebConnection;
    XDataWebClient: TXDataWebClient;
    XDataWebDataSet_User: TXDataWebDataSet;
    XDataWebDataSet_Laundry: TXDataWebDataSet;
    WebDataSource_Laundry: TDataSource;
    XDataWebDataSet_LaundryLaundryID: TIntegerField;
    XDataWebDataSet_LaundryUserID: TIntegerField;
    XDataWebDataSet_LaundryDeliveryID: TIntegerField;
    XDataWebDataSet_LaundryCustomerID: TIntegerField;
    XDataWebDataSet_LaundryComment: TStringField;
    XDataWebDataSet_LaundryCreated: TDateTimeField;
    XDataWebDataSet_LaundryModified: TDateTimeField;
    XDataWebDataSet_LaundryDirty: TIntegerField;
    XDataWebDataSet_LaundryEmptyNeeded: TIntegerField;
    XDataWebDataSet_LaundryEmptyBack: TIntegerField;
    XDataWebDataSet_Auftrag: TXDataWebDataSet;
    WebDataSource_Auftrag: TDataSource;
    XDataWebDataSet_AuftragNr: TIntegerField;
    XDataWebDataSet_AuftragKdnr: TIntegerField;
    XDataWebDataSet_AuftragFahrernr: TIntegerField;
    XDataWebDataSet_AuftragKommentartemp: TStringField;
    XDataWebDataSet_AuftragKommentarfest: TStringField;
    XDataWebDataSet_AuftragZeit: TDateTimeField;
    XDataWebDataSet_AuftragDatum: TDateTimeField;
    XDataWebDataSet_AuftragArt: TIntegerField;
    XDataWebDataSet_AuftragStatus: TIntegerField;
    XDataWebDataSet_Auftragaktiv: TIntegerField;
    XDataWebDataSet_Auftragholenliefern: TIntegerField;
    XDataWebDataSet_Auftragsollnicht: TIntegerField;
    XDataWebDataSet_AuftragTour: TIntegerField;
    XDataWebDataSet_AuftragTourstart: TDateTimeField;
    XDataWebDataSet_AuftragLieferschein: TIntegerField;
    XDataWebDataSet_AuftragfuerLieferscheinfreigegeben: TIntegerField;
    XDataWebDataSet_AuftragOekoNR: TStringField;
    XDataWebDataSet_AuftragFrage: TStringField;
    XDataWebDataSet_Auftragfehlerhaft: TIntegerField;
    XDataWebDataSet_Auftragausgewertet: TIntegerField;
    XDataWebDataSet_AuftragKuchenwasche: TIntegerField;
    XDataWebDataSet_Auftragaenderungperhand: TStringField;
    XDataWebDataSet_AuftragContainerImEingang: TIntegerField;
    XDataWebDataSet_AuftragMemoAbwurf: TStringField;
    XDataWebDataSet_AuftragLieferzeit_von: TDateTimeField;
    XDataWebDataSet_AuftragLieferzeit_bis: TDateTimeField;
    XDataWebDataSet_AuftragGeschaetzte_Container: TIntegerField;
    XDataWebDataSet_AuftragTourNr: TIntegerField;
    XDataWebDataSet_AuftragTourPos: TIntegerField;
    XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben: TIntegerField;
    XDataWebDataSet_AuftragTour_fixiert: TIntegerField;
    XDataWebDataSet_AuftragAnkunft_Kunde: TDateTimeField;
    XDataWebDataSet_AuftragSpaetestens_in_Waescherei: TDateTimeField;
    XDataWebDataSet_AuftragFruehesterStart: TDateTimeField;
    XDataWebDataSet_AuftragHauptkunde: TIntegerField;
    XDataWebDataSet_AuftragAbrechnungsartunterkunden: TIntegerField;
    XDataWebDataSet_AuftragDurchFahrerGeliefert: TIntegerField;
    WebHttpRequestConfig: THttpRequest;
    WebDataSource_Messaging: TDataSource;
    XDataWebDataSet_Messaging: TXDataWebDataSet;
    procedure WebDataModuleCreate(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebConnectionConnect(Sender: TObject);
    procedure XDataWebConnectionError(Error: TXDataWebConnectionError);
    procedure XDataWebConnectionRequest(Args: TXDataWebConnectionRequest);
  private
    { Private declarations }
    FForm: String;
    FServerURL: string;
    FfrmLogin: TfrmLogin;
    FOrderNr: string;
    FUserID: integer;
    FAccessToken: string;
    FCustomerName: string;
    FLoginToken: string;
    FJumpToPage: string;
    FMail: string;
    FSMTPToken: string;
    FCustomerID: integer;
    FSMTPHost: string;
    FSMTPPort: string;
    FSMTPPassword: string;
    FSMTPUser: string;
    FLogisticRights: Boolean;
    FAdminRights: Boolean;
    FPasswordToken: String;
    procedure SetForm(const Value: String);
    procedure SetServerURL(const Value: string);
    procedure SetfrmLogin(const Value: TfrmLogin);
    procedure SetAccessToken(const Value: string);
    procedure SetCustomerName(const Value: string);
    procedure SetJumpToPage(const Value: string);
    procedure SetLoginToken(const Value: string);
    procedure SetOrderNr(const Value: string);
    procedure SetUserID(const Value: integer);
    [async]procedure CreateLoginForm; async;
    [async]procedure Init; async;
    procedure SetMail(const Value: string);
    procedure SetSMTPToken(const Value: string);
    procedure SetCustomerID(const Value: integer);
    procedure SetSMTPHost(const Value: string);
    procedure SetSMTPPassword(const Value: string);
    procedure SetSMTPPort(const Value: string);
    procedure SetSMTPUser(const Value: string);
    procedure SetAdminRights(const Value: Boolean);
    procedure SetLogisticRights(const Value: Boolean);
    procedure SetPasswordToken(const Value: String);

  public
    { Public declarations }
    property Form: String read FForm write SetForm;
    property ServerURL: string read FServerURL write SetServerURL;
    property frmLogin: TfrmLogin read FfrmLogin write SetfrmLogin;
    property AccessToken: string read FAccessToken write SetAccessToken;
    property CustomerName: string read FCustomerName write SetCustomerName;
    property CustomerID: integer read FCustomerID write SetCustomerID;
    property AdminRights : Boolean read FAdminRights write SetAdminRights;
    property LogisticRights : Boolean read FLogisticRights write SetLogisticRights;
    property UserID: integer read FUserID write SetUserID;
    property UserMail: string read FMail write SetMail;
    property LoginToken: string read FLoginToken write SetLoginToken;
    property JumpToPage: string read FJumpToPage write SetJumpToPage;
    property OrderNr: string read FOrderNr write SetOrderNr;
    property PasswordToken : String read FPasswordToken write SetPasswordToken;
    property SMTPToken: string read FSMTPToken write SetSMTPToken;
    property SMTPHost: string read FSMTPHost write SetSMTPHost;
    property SMTPPort: string read FSMTPPort write SetSMTPPort;
    property SMTPUser: string read FSMTPUser write SetSMTPUser;
    property SMTPPassword: string read FSMTPPassword write SetSMTPPassword;
  protected procedure LoadDFMValues; override; end;

var
  UDM: TUDM;

implementation

{%CLASSGROUP 'Vcl.Controls.TControl'}

{$R *.dfm}
uses  UHelper, UResources;

procedure TUDM.WebDataModuleCreate(Sender: TObject);
begin
  Init;
end;

procedure TUDM.Init;
var
  ConfigResponse: TJSXMLHttpRequest;
  ConfigData, SMTPDetails: TJSONObject;
  ConfigFile: string;
begin
  XDataWebConnection.URL := '';
  XDataWebConnection.Connected := False;
  try
    asm
      ConfigFile = window.location.origin+(window.location.pathname.split('/').slice(0,-1).join('/')+'/config.json').replace('/\/\//g','/');
    end;
    WebHttpRequestConfig.URL := ConfigFile;
    ConfigResponse := await(TJSXMLHttpRequest, WebHttpRequestConfig.Perform());
    {$IFDEF DEBUG}
    console.log(ConfigResponse);
    {$ENDIF}
    if String(ConfigResponse.Response) <> '' then
    begin
      ConfigData := TJSONObject.ParseJSONValue(String(ConfigResponse.Response)) as TJSONObject;
      SMTPDetails := TJSONObject.ParseJSONValue((ConfigData.GetValue('smtpDetails').ToString)) as TJSONObject;
      ServerURL := (ConfigData.GetValue('server') as TJSONString).Value;
      SMTPHost := (SMTPDetails.GetValue('smtpHost') as TJSONString).Value;
      SMTPPort := (SMTPDetails.GetValue('smtpPort') as TJSONString).Value;
      SMTPUser := (SMTPDetails.GetValue('smtpUser') as TJSONString).Value;
      SMTPPassword := (SMTPDetails.GetValue('smtpPassword') as TJSONString).Value;

      if ServerURL <> '' then
      begin
        XDataWebConnection.URL := ServerURL;
//        XDataWebConnection.Connected := true;
        await(XDataWebConnection.OpenAsync);
        THelper.DebugODS(ServerURL)
      end;
    end;
  except on E:Exception do
    begin
      exit;
    end
  end;
  if (ServerURL = '') then
  begin
    // server needs to have cors disabled
    ServerURL := 'http://100.94.103.38:9000/tms/xdata/';   // or any default server location
    XDataWebConnection.URL := ServerURL;
    await(XDataWebConnection.OpenAsync);
//    MessageDlg('The server is unavailable, pleae try again later.', mtinformation, [mbOK]);
  end;
end;

procedure TUDM.SetAccessToken(const Value: string);
begin
  FAccessToken := Value;
end;

procedure TUDM.SetAdminRights(const Value: Boolean);
begin
  FAdminRights := Value;
end;

procedure TUDM.SetCustomerID(const Value: integer);
begin
  FCustomerID := Value;
end;

procedure TUDM.SetCustomerName(const Value: string);
begin
  FCustomerName := Value;
end;

procedure TUDM.SetForm(const Value: String);
begin
  FForm := Value;
end;

procedure TUDM.SetfrmLogin(const Value: TfrmLogin);
begin
  FfrmLogin := Value;
end;

procedure TUDM.SetJumpToPage(const Value: string);
begin
  FJumpToPage := Value;
end;

procedure TUDM.SetLoginToken(const Value: string);
begin
  FLoginToken := Value;
end;

procedure TUDM.SetLogisticRights(const Value: Boolean);
begin
  FLogisticRights := Value;
end;

procedure TUDM.SetMail(const Value: string);
begin
  FMail := Value;
end;

procedure TUDM.SetOrderNr(const Value: string);
begin
  FOrderNr := Value;
end;

procedure TUDM.SetPasswordToken(const Value: String);
begin
  FPasswordToken := Value;
end;

procedure TUDM.SetServerURL(const Value: string);
begin
  FServerURL := Value;
end;

procedure TUDM.SetSMTPHost(const Value: string);
begin
  FSMTPHost := Value;
end;

procedure TUDM.SetSMTPPassword(const Value: string);
begin
  FSMTPPassword := Value;
end;

procedure TUDM.SetSMTPPort(const Value: string);
begin
  FSMTPPort := Value;
end;

procedure TUDM.SetSMTPToken(const Value: string);
begin
  FSMTPToken := Value;
end;

procedure TUDM.SetSMTPUser(const Value: string);
begin
  FSMTPUser := Value;
end;

procedure TUDM.SetUserID(const Value: integer);
begin
  FUserID := Value;
end;


procedure TUDM.CreateLoginForm;
begin
  frmLogin := TfrmLogin.CreateNew('wcIDProjectMain', nil);
  // or application opens in a weird popup
  frmLogin.Popup := false;
  try
//    await(TfrmLogin, frmLogin.Load);

  finally
  end;
  //  await(TModalResult, frmLogin.Execute);
end;

procedure TUDM.XDataWebClientError(Error: TXDataClientError);
begin
  {$IFDEF DEBUG}
  OutputDebugString(DateTimeToStr(Now) + ': ' + Error.ErrorMessage);
  {$ENDIF}
end;

procedure TUDM.XDataWebConnectionConnect(Sender: TObject);
begin
  // Connection completes here
  CreateLoginForm;
end;

procedure TUDM.XDataWebConnectionError(Error: TXDataWebConnectionError);
begin
//  MessageDlg('The server is unavailable, pleae try again later.', mtinformation, [mbOK]);
end;

procedure TUDM.XDataWebConnectionRequest(Args: TXDataWebConnectionRequest);
begin
  if AccessToken <> '' then
    Args.Request.Headers.SetValue('Authorization', 'Bearer '+ AccessToken);
end;

procedure TUDM.LoadDFMValues;
begin
  inherited LoadDFMValues;

  XDataWebConnection := TXDataWebConnection.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);
  XDataWebDataSet_User := TXDataWebDataSet.Create(Self);
  XDataWebDataSet_Laundry := TXDataWebDataSet.Create(Self);
  XDataWebDataSet_LaundryLaundryID := TIntegerField.Create(Self);
  XDataWebDataSet_LaundryUserID := TIntegerField.Create(Self);
  XDataWebDataSet_LaundryDeliveryID := TIntegerField.Create(Self);
  XDataWebDataSet_LaundryCustomerID := TIntegerField.Create(Self);
  XDataWebDataSet_LaundryComment := TStringField.Create(Self);
  XDataWebDataSet_LaundryCreated := TDateTimeField.Create(Self);
  XDataWebDataSet_LaundryModified := TDateTimeField.Create(Self);
  XDataWebDataSet_LaundryDirty := TIntegerField.Create(Self);
  XDataWebDataSet_LaundryEmptyNeeded := TIntegerField.Create(Self);
  XDataWebDataSet_LaundryEmptyBack := TIntegerField.Create(Self);
  WebDataSource_Laundry := TDataSource.Create(Self);
  XDataWebDataSet_Auftrag := TXDataWebDataSet.Create(Self);
  XDataWebDataSet_AuftragNr := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragKdnr := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragFahrernr := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragKommentartemp := TStringField.Create(Self);
  XDataWebDataSet_AuftragKommentarfest := TStringField.Create(Self);
  XDataWebDataSet_AuftragZeit := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragDatum := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragArt := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragStatus := TIntegerField.Create(Self);
  XDataWebDataSet_Auftragaktiv := TIntegerField.Create(Self);
  XDataWebDataSet_Auftragholenliefern := TIntegerField.Create(Self);
  XDataWebDataSet_Auftragsollnicht := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragTour := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragTourstart := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragLieferschein := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragfuerLieferscheinfreigegeben := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragOekoNR := TStringField.Create(Self);
  XDataWebDataSet_AuftragFrage := TStringField.Create(Self);
  XDataWebDataSet_Auftragfehlerhaft := TIntegerField.Create(Self);
  XDataWebDataSet_Auftragausgewertet := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragKuchenwasche := TIntegerField.Create(Self);
  XDataWebDataSet_Auftragaenderungperhand := TStringField.Create(Self);
  XDataWebDataSet_AuftragContainerImEingang := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragMemoAbwurf := TStringField.Create(Self);
  XDataWebDataSet_AuftragLieferzeit_von := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragLieferzeit_bis := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragGeschaetzte_Container := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragTourNr := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragTourPos := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragTour_fixiert := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragAnkunft_Kunde := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragSpaetestens_in_Waescherei := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragFruehesterStart := TDateTimeField.Create(Self);
  XDataWebDataSet_AuftragHauptkunde := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragAbrechnungsartunterkunden := TIntegerField.Create(Self);
  XDataWebDataSet_AuftragDurchFahrerGeliefert := TIntegerField.Create(Self);
  WebDataSource_Auftrag := TDataSource.Create(Self);
  WebHttpRequestConfig := THttpRequest.Create(Self);
  WebDataSource_Messaging := TDataSource.Create(Self);
  XDataWebDataSet_Messaging := TXDataWebDataSet.Create(Self);

  XDataWebConnection.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  XDataWebDataSet_User.BeforeLoadDFMValues;
  XDataWebDataSet_Laundry.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryLaundryID.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryUserID.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryDeliveryID.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryCustomerID.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryComment.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryCreated.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryModified.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryDirty.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryEmptyNeeded.BeforeLoadDFMValues;
  XDataWebDataSet_LaundryEmptyBack.BeforeLoadDFMValues;
  WebDataSource_Laundry.BeforeLoadDFMValues;
  XDataWebDataSet_Auftrag.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragNr.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragKdnr.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragFahrernr.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragKommentartemp.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragKommentarfest.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragZeit.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragDatum.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragArt.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragStatus.BeforeLoadDFMValues;
  XDataWebDataSet_Auftragaktiv.BeforeLoadDFMValues;
  XDataWebDataSet_Auftragholenliefern.BeforeLoadDFMValues;
  XDataWebDataSet_Auftragsollnicht.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragTour.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragTourstart.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragLieferschein.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragfuerLieferscheinfreigegeben.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragOekoNR.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragFrage.BeforeLoadDFMValues;
  XDataWebDataSet_Auftragfehlerhaft.BeforeLoadDFMValues;
  XDataWebDataSet_Auftragausgewertet.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragKuchenwasche.BeforeLoadDFMValues;
  XDataWebDataSet_Auftragaenderungperhand.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragContainerImEingang.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragMemoAbwurf.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragLieferzeit_von.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragLieferzeit_bis.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragGeschaetzte_Container.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragTourNr.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragTourPos.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragTour_fixiert.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragAnkunft_Kunde.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragSpaetestens_in_Waescherei.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragFruehesterStart.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragHauptkunde.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragAbrechnungsartunterkunden.BeforeLoadDFMValues;
  XDataWebDataSet_AuftragDurchFahrerGeliefert.BeforeLoadDFMValues;
  WebDataSource_Auftrag.BeforeLoadDFMValues;
  WebHttpRequestConfig.BeforeLoadDFMValues;
  WebDataSource_Messaging.BeforeLoadDFMValues;
  XDataWebDataSet_Messaging.BeforeLoadDFMValues;
  try
    Name := 'UDM';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    Height := 329;
    Width := 565;
    XDataWebConnection.SetParentComponent(Self);
    XDataWebConnection.Name := 'XDataWebConnection';
    SetEvent(XDataWebConnection, Self, 'OnConnect', 'XDataWebConnectionConnect');
    SetEvent(XDataWebConnection, Self, 'OnError', 'XDataWebConnectionError');
    SetEvent(XDataWebConnection, Self, 'OnRequest', 'XDataWebConnectionRequest');
    XDataWebConnection.Left := 48;
    XDataWebConnection.Top := 32;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := XDataWebConnection;
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 152;
    XDataWebClient.Top := 32;
    XDataWebDataSet_User.SetParentComponent(Self);
    XDataWebDataSet_User.Name := 'XDataWebDataSet_User';
    XDataWebDataSet_User.EntitySetName := 'User';
    XDataWebDataSet_User.Connection := XDataWebConnection;
    XDataWebDataSet_User.Left := 56;
    XDataWebDataSet_User.Top := 160;
    XDataWebDataSet_Laundry.SetParentComponent(Self);
    XDataWebDataSet_Laundry.Name := 'XDataWebDataSet_Laundry';
    XDataWebDataSet_Laundry.EntitySetName := 'Laundry';
    XDataWebDataSet_Laundry.Connection := XDataWebConnection;
    XDataWebDataSet_Laundry.Left := 200;
    XDataWebDataSet_Laundry.Top := 160;
    XDataWebDataSet_LaundryLaundryID.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryLaundryID.Name := 'XDataWebDataSet_LaundryLaundryID';
    XDataWebDataSet_LaundryLaundryID.FieldName := 'LaundryID';
    XDataWebDataSet_LaundryLaundryID.Required := True;
    XDataWebDataSet_LaundryUserID.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryUserID.Name := 'XDataWebDataSet_LaundryUserID';
    XDataWebDataSet_LaundryUserID.FieldName := 'UserID';
    XDataWebDataSet_LaundryUserID.Required := True;
    XDataWebDataSet_LaundryDeliveryID.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryDeliveryID.Name := 'XDataWebDataSet_LaundryDeliveryID';
    XDataWebDataSet_LaundryDeliveryID.FieldName := 'DeliveryID';
    XDataWebDataSet_LaundryDeliveryID.Required := True;
    XDataWebDataSet_LaundryCustomerID.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryCustomerID.Name := 'XDataWebDataSet_LaundryCustomerID';
    XDataWebDataSet_LaundryCustomerID.FieldName := 'CustomerID';
    XDataWebDataSet_LaundryCustomerID.Required := True;
    XDataWebDataSet_LaundryComment.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryComment.Name := 'XDataWebDataSet_LaundryComment';
    XDataWebDataSet_LaundryComment.FieldName := 'Comment';
    XDataWebDataSet_LaundryComment.Required := True;
    XDataWebDataSet_LaundryComment.Size := 255;
    XDataWebDataSet_LaundryCreated.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryCreated.Name := 'XDataWebDataSet_LaundryCreated';
    XDataWebDataSet_LaundryCreated.FieldName := 'Created';
    XDataWebDataSet_LaundryCreated.Required := True;
    XDataWebDataSet_LaundryModified.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryModified.Name := 'XDataWebDataSet_LaundryModified';
    XDataWebDataSet_LaundryModified.FieldName := 'Modified';
    XDataWebDataSet_LaundryModified.Required := True;
    XDataWebDataSet_LaundryDirty.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryDirty.Name := 'XDataWebDataSet_LaundryDirty';
    XDataWebDataSet_LaundryDirty.FieldName := 'Dirty';
    XDataWebDataSet_LaundryDirty.Required := True;
    XDataWebDataSet_LaundryEmptyNeeded.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryEmptyNeeded.Name := 'XDataWebDataSet_LaundryEmptyNeeded';
    XDataWebDataSet_LaundryEmptyNeeded.FieldName := 'EmptyNeeded';
    XDataWebDataSet_LaundryEmptyNeeded.Required := True;
    XDataWebDataSet_LaundryEmptyBack.SetParentComponent(XDataWebDataSet_Laundry);
    XDataWebDataSet_LaundryEmptyBack.Name := 'XDataWebDataSet_LaundryEmptyBack';
    XDataWebDataSet_LaundryEmptyBack.FieldName := 'EmptyBack';
    XDataWebDataSet_LaundryEmptyBack.Required := True;
    WebDataSource_Laundry.SetParentComponent(Self);
    WebDataSource_Laundry.Name := 'WebDataSource_Laundry';
    WebDataSource_Laundry.DataSet := XDataWebDataSet_Laundry;
    WebDataSource_Laundry.Left := 200;
    WebDataSource_Laundry.Top := 232;
    XDataWebDataSet_Auftrag.SetParentComponent(Self);
    XDataWebDataSet_Auftrag.Name := 'XDataWebDataSet_Auftrag';
    XDataWebDataSet_Auftrag.EntitySetName := 'auftrag';
    XDataWebDataSet_Auftrag.Left := 344;
    XDataWebDataSet_Auftrag.Top := 160;
    XDataWebDataSet_AuftragNr.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragNr.Name := 'XDataWebDataSet_AuftragNr';
    XDataWebDataSet_AuftragNr.FieldName := 'Nr';
    XDataWebDataSet_AuftragNr.Required := True;
    XDataWebDataSet_AuftragKdnr.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragKdnr.Name := 'XDataWebDataSet_AuftragKdnr';
    XDataWebDataSet_AuftragKdnr.FieldName := 'Kdnr';
    XDataWebDataSet_AuftragKdnr.Required := True;
    XDataWebDataSet_AuftragFahrernr.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragFahrernr.Name := 'XDataWebDataSet_AuftragFahrernr';
    XDataWebDataSet_AuftragFahrernr.FieldName := 'Fahrernr';
    XDataWebDataSet_AuftragFahrernr.Required := True;
    XDataWebDataSet_AuftragKommentartemp.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragKommentartemp.Name := 'XDataWebDataSet_AuftragKommentartemp';
    XDataWebDataSet_AuftragKommentartemp.FieldName := 'Kommentartemp';
    XDataWebDataSet_AuftragKommentartemp.Required := True;
    XDataWebDataSet_AuftragKommentartemp.Size := 500;
    XDataWebDataSet_AuftragKommentarfest.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragKommentarfest.Name := 'XDataWebDataSet_AuftragKommentarfest';
    XDataWebDataSet_AuftragKommentarfest.FieldName := 'Kommentarfest';
    XDataWebDataSet_AuftragKommentarfest.Required := True;
    XDataWebDataSet_AuftragKommentarfest.Size := 500;
    XDataWebDataSet_AuftragZeit.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragZeit.Name := 'XDataWebDataSet_AuftragZeit';
    XDataWebDataSet_AuftragZeit.FieldName := 'Zeit';
    XDataWebDataSet_AuftragZeit.Required := True;
    XDataWebDataSet_AuftragDatum.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragDatum.Name := 'XDataWebDataSet_AuftragDatum';
    XDataWebDataSet_AuftragDatum.FieldName := 'Datum';
    XDataWebDataSet_AuftragDatum.Required := True;
    XDataWebDataSet_AuftragArt.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragArt.Name := 'XDataWebDataSet_AuftragArt';
    XDataWebDataSet_AuftragArt.FieldName := 'Art';
    XDataWebDataSet_AuftragArt.Required := True;
    XDataWebDataSet_AuftragStatus.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragStatus.Name := 'XDataWebDataSet_AuftragStatus';
    XDataWebDataSet_AuftragStatus.FieldName := 'Status';
    XDataWebDataSet_AuftragStatus.Required := True;
    XDataWebDataSet_Auftragaktiv.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_Auftragaktiv.Name := 'XDataWebDataSet_Auftragaktiv';
    XDataWebDataSet_Auftragaktiv.FieldName := 'aktiv';
    XDataWebDataSet_Auftragaktiv.Required := True;
    XDataWebDataSet_Auftragholenliefern.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_Auftragholenliefern.Name := 'XDataWebDataSet_Auftragholenliefern';
    XDataWebDataSet_Auftragholenliefern.FieldName := 'holenliefern';
    XDataWebDataSet_Auftragholenliefern.Required := True;
    XDataWebDataSet_Auftragsollnicht.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_Auftragsollnicht.Name := 'XDataWebDataSet_Auftragsollnicht';
    XDataWebDataSet_Auftragsollnicht.FieldName := 'sollnicht';
    XDataWebDataSet_Auftragsollnicht.Required := True;
    XDataWebDataSet_AuftragTour.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragTour.Name := 'XDataWebDataSet_AuftragTour';
    XDataWebDataSet_AuftragTour.FieldName := 'Tour';
    XDataWebDataSet_AuftragTour.Required := True;
    XDataWebDataSet_AuftragTourstart.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragTourstart.Name := 'XDataWebDataSet_AuftragTourstart';
    XDataWebDataSet_AuftragTourstart.FieldName := 'Tourstart';
    XDataWebDataSet_AuftragTourstart.Required := True;
    XDataWebDataSet_AuftragLieferschein.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragLieferschein.Name := 'XDataWebDataSet_AuftragLieferschein';
    XDataWebDataSet_AuftragLieferschein.FieldName := 'Lieferschein';
    XDataWebDataSet_AuftragLieferschein.Required := True;
    XDataWebDataSet_AuftragfuerLieferscheinfreigegeben.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragfuerLieferscheinfreigegeben.Name := 'XDataWebDataSet_AuftragfuerLieferscheinfreigegeben';
    XDataWebDataSet_AuftragfuerLieferscheinfreigegeben.FieldName := 'fuerLieferscheinfreigegeben';
    XDataWebDataSet_AuftragfuerLieferscheinfreigegeben.Required := True;
    XDataWebDataSet_AuftragOekoNR.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragOekoNR.Name := 'XDataWebDataSet_AuftragOekoNR';
    XDataWebDataSet_AuftragOekoNR.FieldName := 'OekoNR';
    XDataWebDataSet_AuftragOekoNR.Required := True;
    XDataWebDataSet_AuftragOekoNR.Size := 50;
    XDataWebDataSet_AuftragFrage.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragFrage.Name := 'XDataWebDataSet_AuftragFrage';
    XDataWebDataSet_AuftragFrage.FieldName := 'Frage';
    XDataWebDataSet_AuftragFrage.Required := True;
    XDataWebDataSet_AuftragFrage.Size := 300;
    XDataWebDataSet_Auftragfehlerhaft.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_Auftragfehlerhaft.Name := 'XDataWebDataSet_Auftragfehlerhaft';
    XDataWebDataSet_Auftragfehlerhaft.FieldName := 'fehlerhaft';
    XDataWebDataSet_Auftragfehlerhaft.Required := True;
    XDataWebDataSet_Auftragausgewertet.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_Auftragausgewertet.Name := 'XDataWebDataSet_Auftragausgewertet';
    XDataWebDataSet_Auftragausgewertet.FieldName := 'ausgewertet';
    XDataWebDataSet_Auftragausgewertet.Required := True;
    XDataWebDataSet_AuftragKuchenwasche.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragKuchenwasche.Name := 'XDataWebDataSet_AuftragKuchenwasche';
    XDataWebDataSet_AuftragKuchenwasche.FieldName := 'Kuchenwasche';
    XDataWebDataSet_AuftragKuchenwasche.Required := True;
    XDataWebDataSet_Auftragaenderungperhand.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_Auftragaenderungperhand.Name := 'XDataWebDataSet_Auftragaenderungperhand';
    XDataWebDataSet_Auftragaenderungperhand.FieldName := 'aenderungperhand';
    XDataWebDataSet_Auftragaenderungperhand.Required := True;
    XDataWebDataSet_Auftragaenderungperhand.Size := 5;
    XDataWebDataSet_AuftragContainerImEingang.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragContainerImEingang.Name := 'XDataWebDataSet_AuftragContainerImEingang';
    XDataWebDataSet_AuftragContainerImEingang.FieldName := 'ContainerImEingang';
    XDataWebDataSet_AuftragContainerImEingang.Required := True;
    XDataWebDataSet_AuftragMemoAbwurf.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragMemoAbwurf.Name := 'XDataWebDataSet_AuftragMemoAbwurf';
    XDataWebDataSet_AuftragMemoAbwurf.FieldName := 'MemoAbwurf';
    XDataWebDataSet_AuftragMemoAbwurf.Required := True;
    XDataWebDataSet_AuftragMemoAbwurf.Size := 2000;
    XDataWebDataSet_AuftragLieferzeit_von.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragLieferzeit_von.Name := 'XDataWebDataSet_AuftragLieferzeit_von';
    XDataWebDataSet_AuftragLieferzeit_von.FieldName := 'Lieferzeit_von';
    XDataWebDataSet_AuftragLieferzeit_bis.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragLieferzeit_bis.Name := 'XDataWebDataSet_AuftragLieferzeit_bis';
    XDataWebDataSet_AuftragLieferzeit_bis.FieldName := 'Lieferzeit_bis';
    XDataWebDataSet_AuftragGeschaetzte_Container.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragGeschaetzte_Container.Name := 'XDataWebDataSet_AuftragGeschaetzte_Container';
    XDataWebDataSet_AuftragGeschaetzte_Container.FieldName := 'Geschaetzte_Container';
    XDataWebDataSet_AuftragTourNr.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragTourNr.Name := 'XDataWebDataSet_AuftragTourNr';
    XDataWebDataSet_AuftragTourNr.FieldName := 'TourNr';
    XDataWebDataSet_AuftragTourPos.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragTourPos.Name := 'XDataWebDataSet_AuftragTourPos';
    XDataWebDataSet_AuftragTourPos.FieldName := 'TourPos';
    XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben.Name := 'XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben';
    XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben.FieldName := 'An_Tourenplaung_uebergeben';
    XDataWebDataSet_AuftragTour_fixiert.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragTour_fixiert.Name := 'XDataWebDataSet_AuftragTour_fixiert';
    XDataWebDataSet_AuftragTour_fixiert.FieldName := 'Tour_fixiert';
    XDataWebDataSet_AuftragAnkunft_Kunde.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragAnkunft_Kunde.Name := 'XDataWebDataSet_AuftragAnkunft_Kunde';
    XDataWebDataSet_AuftragAnkunft_Kunde.FieldName := 'Ankunft_Kunde';
    XDataWebDataSet_AuftragSpaetestens_in_Waescherei.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragSpaetestens_in_Waescherei.Name := 'XDataWebDataSet_AuftragSpaetestens_in_Waescherei';
    XDataWebDataSet_AuftragSpaetestens_in_Waescherei.FieldName := 'Spaetestens_in_Waescherei';
    XDataWebDataSet_AuftragSpaetestens_in_Waescherei.Required := True;
    XDataWebDataSet_AuftragFruehesterStart.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragFruehesterStart.Name := 'XDataWebDataSet_AuftragFruehesterStart';
    XDataWebDataSet_AuftragFruehesterStart.FieldName := 'FruehesterStart';
    XDataWebDataSet_AuftragFruehesterStart.Required := True;
    XDataWebDataSet_AuftragHauptkunde.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragHauptkunde.Name := 'XDataWebDataSet_AuftragHauptkunde';
    XDataWebDataSet_AuftragHauptkunde.FieldName := 'Hauptkunde';
    XDataWebDataSet_AuftragHauptkunde.Required := True;
    XDataWebDataSet_AuftragAbrechnungsartunterkunden.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragAbrechnungsartunterkunden.Name := 'XDataWebDataSet_AuftragAbrechnungsartunterkunden';
    XDataWebDataSet_AuftragAbrechnungsartunterkunden.FieldName := 'Abrechnungsartunterkunden';
    XDataWebDataSet_AuftragAbrechnungsartunterkunden.Required := True;
    XDataWebDataSet_AuftragDurchFahrerGeliefert.SetParentComponent(XDataWebDataSet_Auftrag);
    XDataWebDataSet_AuftragDurchFahrerGeliefert.Name := 'XDataWebDataSet_AuftragDurchFahrerGeliefert';
    XDataWebDataSet_AuftragDurchFahrerGeliefert.FieldName := 'DurchFahrerGeliefert';
    XDataWebDataSet_AuftragDurchFahrerGeliefert.Required := True;
    WebDataSource_Auftrag.SetParentComponent(Self);
    WebDataSource_Auftrag.Name := 'WebDataSource_Auftrag';
    WebDataSource_Auftrag.DataSet := XDataWebDataSet_Auftrag;
    WebDataSource_Auftrag.Left := 336;
    WebDataSource_Auftrag.Top := 232;
    WebHttpRequestConfig.SetParentComponent(Self);
    WebHttpRequestConfig.Name := 'WebHttpRequestConfig';
    WebHttpRequestConfig.Left := 392;
    WebHttpRequestConfig.Top := 56;
    WebDataSource_Messaging.SetParentComponent(Self);
    WebDataSource_Messaging.Name := 'WebDataSource_Messaging';
    WebDataSource_Messaging.DataSet := XDataWebDataSet_Messaging;
    WebDataSource_Messaging.Left := 464;
    WebDataSource_Messaging.Top := 232;
    XDataWebDataSet_Messaging.SetParentComponent(Self);
    XDataWebDataSet_Messaging.Name := 'XDataWebDataSet_Messaging';
    XDataWebDataSet_Messaging.Connection := XDataWebConnection;
    XDataWebDataSet_Messaging.Left := 464;
    XDataWebDataSet_Messaging.Top := 160;
  finally
    XDataWebConnection.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
    XDataWebDataSet_User.AfterLoadDFMValues;
    XDataWebDataSet_Laundry.AfterLoadDFMValues;
    XDataWebDataSet_LaundryLaundryID.AfterLoadDFMValues;
    XDataWebDataSet_LaundryUserID.AfterLoadDFMValues;
    XDataWebDataSet_LaundryDeliveryID.AfterLoadDFMValues;
    XDataWebDataSet_LaundryCustomerID.AfterLoadDFMValues;
    XDataWebDataSet_LaundryComment.AfterLoadDFMValues;
    XDataWebDataSet_LaundryCreated.AfterLoadDFMValues;
    XDataWebDataSet_LaundryModified.AfterLoadDFMValues;
    XDataWebDataSet_LaundryDirty.AfterLoadDFMValues;
    XDataWebDataSet_LaundryEmptyNeeded.AfterLoadDFMValues;
    XDataWebDataSet_LaundryEmptyBack.AfterLoadDFMValues;
    WebDataSource_Laundry.AfterLoadDFMValues;
    XDataWebDataSet_Auftrag.AfterLoadDFMValues;
    XDataWebDataSet_AuftragNr.AfterLoadDFMValues;
    XDataWebDataSet_AuftragKdnr.AfterLoadDFMValues;
    XDataWebDataSet_AuftragFahrernr.AfterLoadDFMValues;
    XDataWebDataSet_AuftragKommentartemp.AfterLoadDFMValues;
    XDataWebDataSet_AuftragKommentarfest.AfterLoadDFMValues;
    XDataWebDataSet_AuftragZeit.AfterLoadDFMValues;
    XDataWebDataSet_AuftragDatum.AfterLoadDFMValues;
    XDataWebDataSet_AuftragArt.AfterLoadDFMValues;
    XDataWebDataSet_AuftragStatus.AfterLoadDFMValues;
    XDataWebDataSet_Auftragaktiv.AfterLoadDFMValues;
    XDataWebDataSet_Auftragholenliefern.AfterLoadDFMValues;
    XDataWebDataSet_Auftragsollnicht.AfterLoadDFMValues;
    XDataWebDataSet_AuftragTour.AfterLoadDFMValues;
    XDataWebDataSet_AuftragTourstart.AfterLoadDFMValues;
    XDataWebDataSet_AuftragLieferschein.AfterLoadDFMValues;
    XDataWebDataSet_AuftragfuerLieferscheinfreigegeben.AfterLoadDFMValues;
    XDataWebDataSet_AuftragOekoNR.AfterLoadDFMValues;
    XDataWebDataSet_AuftragFrage.AfterLoadDFMValues;
    XDataWebDataSet_Auftragfehlerhaft.AfterLoadDFMValues;
    XDataWebDataSet_Auftragausgewertet.AfterLoadDFMValues;
    XDataWebDataSet_AuftragKuchenwasche.AfterLoadDFMValues;
    XDataWebDataSet_Auftragaenderungperhand.AfterLoadDFMValues;
    XDataWebDataSet_AuftragContainerImEingang.AfterLoadDFMValues;
    XDataWebDataSet_AuftragMemoAbwurf.AfterLoadDFMValues;
    XDataWebDataSet_AuftragLieferzeit_von.AfterLoadDFMValues;
    XDataWebDataSet_AuftragLieferzeit_bis.AfterLoadDFMValues;
    XDataWebDataSet_AuftragGeschaetzte_Container.AfterLoadDFMValues;
    XDataWebDataSet_AuftragTourNr.AfterLoadDFMValues;
    XDataWebDataSet_AuftragTourPos.AfterLoadDFMValues;
    XDataWebDataSet_AuftragAn_Tourenplaung_uebergeben.AfterLoadDFMValues;
    XDataWebDataSet_AuftragTour_fixiert.AfterLoadDFMValues;
    XDataWebDataSet_AuftragAnkunft_Kunde.AfterLoadDFMValues;
    XDataWebDataSet_AuftragSpaetestens_in_Waescherei.AfterLoadDFMValues;
    XDataWebDataSet_AuftragFruehesterStart.AfterLoadDFMValues;
    XDataWebDataSet_AuftragHauptkunde.AfterLoadDFMValues;
    XDataWebDataSet_AuftragAbrechnungsartunterkunden.AfterLoadDFMValues;
    XDataWebDataSet_AuftragDurchFahrerGeliefert.AfterLoadDFMValues;
    WebDataSource_Auftrag.AfterLoadDFMValues;
    WebHttpRequestConfig.AfterLoadDFMValues;
    WebDataSource_Messaging.AfterLoadDFMValues;
    XDataWebDataSet_Messaging.AfterLoadDFMValues;
  end;
end;

end.
